<template>
  <v-card
    :id="id"
    min-height="350"
    class="pa-8"
    v-if="chart && chart.sum !== '0'"
  >
    <div class="d-flex flex-column mb-4">
      <div class="d-flex">
        <span>
          {{
            $t("message.analytics.businessAddresses.chart.common.totalViews")
          }}
        </span>
        <v-spacer />
        <span>{{ totalViews }}</span>
      </div>
      <div class="d-flex">
        <h4 class="chart-title">
          {{ title }}
        </h4>
        <ChartTitleTooltip
          :tooltip="tooltip"
          :tooltipMaxWidth="tooltipMaxWidth"
          :infoIconColor="infoIconColor"
        />
        <v-spacer />
        <span class="font-weight-bold">
          {{ chart.sum }}
        </span>
      </div>
      <div class="d-flex">
        <span>
          {{
            $t("message.analytics.businessAddresses.chart.common.conversion")
          }}
        </span>
        <v-spacer />
        <span>
          {{ getConversionRate(chart) }}
        </span>
        <LastAudit
          v-if="chart.percentage !== null"
          class="ml-3"
          hideTitle
          showZero
          :lastAudit="chart.percentage"
        />
      </div>
    </div>
    <LineChartRelative
      :height="300"
      :data="chart.data"
      :options="chart.options"
    />
  </v-card>
  <v-card
    min-height="200"
    class="d-flex justify-center align-center fill-height pa-8"
    v-else
  >
    <no-data
      :description="isDateInRange ? $t('message.common.noDataDescription') : ''"
    ></no-data>
  </v-card>
</template>

<script>
import LineChartRelative from "@/components/Analytics/GMBAddresses/chart/LineRelative.js";
import LastAudit from "@/components/ui/ExpansionPanel/Header/LastAudit.vue";
import NoData from "@/components/ui/NoData.vue";
import ChartTitleTooltip from "./ChartTitleTooltip.vue";

export default {
  name: "ChartCard",

  components: {
    LineChartRelative,
    LastAudit,
    NoData,
    ChartTitleTooltip
  },
  props: {
    isDateInRange: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      required: true
    },
    chart: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
    totalViews: {
      type: Number,
      required: true
    },
    infoIconColor: {
      type: String,
      default: "primary"
    },
    tooltipMaxWidth: {
      type: Number,
      default: 500
    }
  },
  methods: {
    getConversionRate(chart) {
      const actionsSum = chart.relatedChartsData
        .map(relatedChartData => relatedChartData.sum)
        .reduce((a, b) => a + b, 0);
      return ((100 * actionsSum) / this.totalViews).toFixed(0) + "%";
    }
  }
};
</script>
